import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import type {ReactNode} from "react";

interface Props {
    title: ReactNode
    actions?: ReactNode
    children: ReactNode
}

const SurveyDetailsSection = ({title, actions, children}: Props) => (
    <Stack gap={{xs: 2.5, sm: 2}}>
        <Stack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={2}
        >
            <Typography
                variant={'h5'}
                textAlign={'start'}
                sx={{fontSize: {xs: '18px', sm: '20px'}, lineHeight: 1.25}}
            >
                {title}
            </Typography>

            {actions}
        </Stack>

        {children}
    </Stack>
);

export default SurveyDetailsSection;
